import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { loadData, deleteData, updateData, addData, baseUrl } from "../../../../config/data";
import Lang from "../../../../config/lang";
import Swal from "sweetalert2";
import axios from "axios";
import { useProfileTab } from "../../ProfileTabContext";

const SocialMediaForm = ({ setIsFading, updatePercentage, profileCompletion }) => {
    const { lang } = useSelector((state) => state.globalReducer);
    const { currentTabIndex, setCurrentTabIndex } = useProfileTab();

    const [isEdit, setIsEdit] = useState(false);
    const [socialMedia, setSocialMedia] = useState({});
    const [linkedin, setlinkedin] = useState('');
    const [github, setgithub] = useState('');
    const [instagram, setinstagram] = useState('');
    const [xUrl, setxUrl] = useState('');
    const [facebook, setfacebook] = useState('');
    const [portfolioURL, setportfolioURL] = useState('');
    const [otherProfileURL, setotherProfileURL] = useState('');
    const applicantID = localStorage?.getItem("applicantID");
    const userToken = localStorage?.getItem('authToken') || '';
    const [canPortfolio, setcanPortfolio] = useState(null);
    const [isFile, setisFile] = useState('');
    const [isLoading, setisLoading] = useState('');

    const isInvalidLinks = () => {
        return (linkedin && !isLink(linkedin)) || (portfolioURL && !isLink(portfolioURL)) || (github && !isLink(github)) || (instagram && !isLink(instagram)) || (xUrl && !isLink(xUrl)) || (facebook && !isLink(facebook));
    }
    const loadSocialMedia = async () => {
        loadData({
            url: `ApplicantSocialMedia`,
            params: [{ title: "filter", value: `applicant:${applicantID}` }],
            userToken,
        }).then((res) => {
            if (res?.data) {
                const resData = res.data[0];
                setSocialMedia(resData);
                setlinkedin(resData?.linkedInURL);
                setgithub(resData?.gitHubURL);
                setinstagram(resData?.instagramURL);
                setxUrl(resData?.x_URL)
                setfacebook(resData?.facebookURL);
                if(resData?.portfolioURL){
                    const portfolio = `${resData.portfolioURL}`.includes('http') ? resData.portfolioURL : `${baseUrl}/${resData.portfolioURL}`
                    setportfolioURL(portfolio);
                }
                setotherProfileURL(resData?.otherProfileURL)
            }
        });
    };

    useEffect(() => {
        loadSocialMedia();
    }, []);


    const saveData = async (socMed, url) => {
        try {
            if (socMed?.socialMediaID) {
                const reqBody = {
                    socialMediaID: socMed?.socialMediaID,
                    applicantID: applicantID,
                    linkedInURL: linkedin,
                    gitHubURL: github,
                    x_URL: xUrl,
                    instagramURL: instagram,
                    facebookURL: facebook,
                    portfolioURL: url ? url : portfolioURL,
                    otherProfileURL: otherProfileURL,
                };
                await updateData({
                    url: "ApplicantSocialMedia",
                    userToken,
                    reqBody: reqBody
                }).then(res => {
                    setIsEdit(false);
                    loadSocialMedia();
                    setisLoading(false);
                    setIsFading(true);
                    setTimeout(() => {
                        if ((currentTabIndex + 1) > profileCompletion) {
                            updatePercentage(currentTabIndex + 1)
                        }
                        setCurrentTabIndex(currentTabIndex + 1);
                        setIsFading(false);
                    }, 200);

                });
            } else {
                await addData({
                    url: "ApplicantSocialMedia",
                    userToken,
                    reqBody: {
                        applicantID: applicantID,
                        linkedInURL: linkedin,
                        gitHubURL: github,
                        x_URL: xUrl,
                        instagramURL: instagram,
                        facebookURL: facebook,
                        portfolioURL: url ? url : portfolioURL,
                        otherProfileURL: otherProfileURL,
                    },
                }).then(res => {
                    setisLoading(false);
                    setIsFading(true);
                    setTimeout(() => {
                        if ((currentTabIndex + 1) > profileCompletion) {
                            updatePercentage(currentTabIndex + 1)
                        }
                        setCurrentTabIndex(currentTabIndex + 1);
                        setIsFading(false);
                    }, 200);
                });
            }
        } catch (err) {
            setIsEdit(false);
            console.error("Failed to save organization:", err);
            showError(err)
        }
    };


    const showError = (error) => {
        Swal.fire({
            title: 'Error!',
            text: error || 'Error',
            icon: 'error',
            timer: 3000,
            showConfirmButton: false,
            customClass: {
                popup: 'my-custom-popup'
            }
        });
    };




    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.type === "application/pdf") {
            setcanPortfolio(selectedFile);
        } else {
            alert(Lang(lang, 'please_select_a_valid_PDF_file'));

            e.target.value = null;
        }
    };

    const handleSave = async () => {
        setisLoading(true)
        if (canPortfolio) {
            uploadPortfolio(canPortfolio)
        } else {
            await saveData(socialMedia);
        }
    };


    const uploadPortfolio = async (file) => {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(
                `${baseUrl}/Candidates/upload`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            if (response?.data) {
                const resData = response?.data;
                setportfolioURL(resData?.attachmentPath)
                await saveData(socialMedia, resData?.attachmentPath);

            } else {
                showError(response);
            }
        } catch (error) {
            showError(error)
            setIsEdit(false);
            console.log('ERROR:', error)
        }
    }

    function isLink(str) {
        try {
            new URL(str);
            return true;
        } catch {
            return false;
        }
    }

    return (
        <div className="">
            <div className="mt-4 bg-white p-6 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.05)]" style={{ minHeight: window.innerHeight - 300 }}>
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-blue-700 font-medium md:text-[20px] text-[17px] flex items-center space-x-2 cursor-pointer">
                        <img src={"/asset/icon/license_blue.svg"} className="w-[16px]" />
                        <span>Social Media</span>
                    </h2>
                    {!isEdit && (
                        <button
                            onClick={() => setIsEdit(true)}
                            className="flex border border-gray-300 rounded-full px-5 py-2 text-sm text-white bg-red-500 hover:bg-red-600"
                        >
                            <img src={"/asset/icon/edit.svg"} className="w-[16px] mr-1" />
                            Edit
                        </button>
                    )}
                </div>

                <form className="space-y-6">
                    {
                        <div
                            className="border border-gray-200 rounded-xl p-4 relative"
                        >
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                                <div>
                                    <label className="block font-medium mb-1">
                                        Linkedin
                                    </label>
                                    {linkedin && !isEdit ?
                                        <a href={linkedin} target="_blank" className="flex flex-row bg-white p-5 shadow-[0px_1px_2px_rgba(0,0,0,0.05)] items-center rounded-xl w-[200px]">
                                            <img src="/asset/icon/linkedin_black.svg" className="w-[30px]" />
                                            <p class='font-medium text-[13px] ml-2 mt-1'>Linkedin</p>
                                        </a>
                                        : <input
                                            type="text"
                                            value={linkedin}
                                            onChange={(e) => setlinkedin(e.target.value)}
                                            className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                                            disabled={!isEdit}
                                        />}
                                    {linkedin && !isLink(linkedin) && <div className="flex justify-start w-full">
                                        <p className="text-red-500 text-xs mt-1 mr-0">{Lang(lang, 'invalid_link')}</p>
                                    </div>}
                                </div>

                                <div>
                                    <label className="block font-medium mb-1">
                                        Github
                                    </label>
                                    {github && !isEdit ?
                                        <a href={github} target="_blank" className="flex flex-row bg-white p-5 shadow-[0px_1px_2px_rgba(0,0,0,0.05)] items-center rounded-xl w-[200px]">
                                            <img src="/asset/icon/github.svg" className="w-[30px]" />
                                            <p class='font-medium text-[13px] ml-2 mt-1'>Github</p>
                                        </a>
                                        : <input
                                            type="text"
                                            value={github}
                                            onChange={(e) => setgithub(e.target.value)}
                                            className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                                            disabled={!isEdit}
                                        />}
                                    {github && !isLink(github) && <div className="flex justify-start w-full">
                                        <p className="text-red-500 text-xs mt-1 mr-0">{Lang(lang, 'invalid_link')}</p>
                                    </div>}
                                </div>

                                <div>
                                    <label className="block font-medium mb-1">Instagram</label>
                                    {instagram && !isEdit ?
                                        <a href={instagram} target="_blank" className="flex flex-row bg-white p-5 shadow-[0px_1px_2px_rgba(0,0,0,0.05)] items-center rounded-xl w-[200px]">
                                            <img src="/asset/icon/instagram.svg" className="w-[30px]" />
                                            <p class='font-medium text-[13px] ml-2 mt-1'>Instagram</p>
                                        </a>
                                        : <input
                                            type="text"
                                            value={instagram}
                                            onChange={(e) => setinstagram(e.target.value)}
                                            className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                                            disabled={!isEdit}
                                        />}
                                    {instagram && !isLink(instagram) && <div className="flex justify-start w-full">
                                        <p className="text-red-500 text-xs mt-1 mr-0">{Lang(lang, 'invalid_link')}</p>
                                    </div>}
                                </div>

                                <div>
                                    <label className="block font-medium mb-1">X</label>
                                    {xUrl && !isEdit ?
                                        <a href={xUrl} target="_blank" className="flex flex-row bg-white p-5 shadow-[0px_1px_2px_rgba(0,0,0,0.05)] items-center rounded-xl w-[200px]">
                                            <img src="/asset/icon/x.svg" className="w-[30px]" />
                                            <p class='font-medium text-[13px] ml-2 mt-1'>X</p>
                                        </a>
                                        : <input
                                            type="text"
                                            value={xUrl}
                                            onChange={(e) => setxUrl(e.target.value)}
                                            className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                                            disabled={!isEdit}
                                        />}
                                    {xUrl && !isLink(xUrl) && <div className="flex justify-start w-full">
                                        <p className="text-red-500 text-xs mt-1 mr-0">{Lang(lang, 'invalid_link')}</p>
                                    </div>}
                                </div>

                                <div>
                                    <div className={`flex justify-start gap-3 items-center text-sm w-full`}>
                                        <label className="block mb-1 font-medium">Portfolio</label>
                                        {isEdit && <label className="flex items-center space-x-2">
                                            <input
                                                type="checkbox"
                                                disabled={!isEdit}
                                                className="form-checkbox text-red-500 mb-1"
                                                checked={isFile}
                                                onChange={(e) => {
                                                    setisFile(!isFile)
                                                }}
                                            />
                                            <span className="text-gray-700">{Lang(lang, 'uploadFile')}</span>
                                        </label>}
                                    </div>

                                    {isFile
                                        ? <input type="file" id="subject" className={`rounded-[35px] job-form border-[#48494B] text-sm p-[16px] pl-[20px] w-full h-[60px] flex flex-col items-center`}
                                            accept="application/pdf" required={true} onChange={handleFileChange} />
                                        : portfolioURL && !isEdit ?
                                            <a href={portfolioURL||''} target="_blank" className="flex flex-row bg-white p-5 shadow-[0px_1px_2px_rgba(0,0,0,0.05)] items-center rounded-xl w-[200px]">
                                                <img src="/asset/icon/view_file.svg" className="w-[30px]" />
                                                <p class='font-medium text-[13px] ml-2 mt-1'>Portfolio</p>
                                            </a>
                                            :
                                            <input type="text" disabled={!isEdit} value={portfolioURL} className={(isEdit ? 'bg-white' : 'bg-gray-100') + " w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"} onChange={(e) => setportfolioURL(e.target.value)} />
                                    }

                                    {(canPortfolio &&
                                        canPortfolio.size >= 2 * 1024 * 1024) && <div className="flex justify-end w-full">
                                            <p className="text-red-500 text-xs mt-1 mr-0">{'PDF file maximum size 2 MB'}</p>
                                        </div>}

                                    {portfolioURL && !isLink(portfolioURL) && <div className="flex justify-start w-full">
                                        <p className="text-red-500 text-xs mt-1 mr-0">{Lang(lang, 'invalid_link')}</p>
                                    </div>}
                                </div>

                            </div>
                        </div>
                    }

                </form>
            </div>

            {isEdit ? (
                <div className="flex space-x-2 mt-3 w-full bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] p-3 rounded-xl sticky bottom-3 justify-end">
                    <button
                        type="button"
                        className="border border-gray-300 rounded-full px-4 py-1 text-sm hover:bg-gray-50"
                        onClick={() => {
                            setIsFading(true);
                            setTimeout(() => {
                                setCurrentTabIndex(currentTabIndex - 1);
                                setIsFading(false);
                            }, 200);
                        }}
                    >
                        {Lang(lang, 'previous')}
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            if (!(canPortfolio &&
                                canPortfolio.size >= 2 * 1024 * 1024) && !isInvalidLinks() && !isLoading) {
                                handleSave()
                            }
                        }}
                        className={(isEdit && !(canPortfolio &&
                            canPortfolio.size >= 2 * 1024 * 1024) ? "text-white bg-red-500 hover:bg-red-600" : "border border-gray-300 hover:bg-gray-50") + " rounded-full px-4 py-2 text-sm"}
                    >
                        {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto" /> : Lang(lang, 'save_and_next')}
                    </button>
                </div>
            ) : <div className="flex space-x-2 mt-3 justify-end w-full bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] p-3 rounded-xl sticky bottom-3 justify-end">
                <button
                    type="button"
                    className="border border-gray-300 rounded-full px-4 py-1 text-sm hover:bg-gray-50"
                    onClick={() => {
                        setIsFading(true);
                        setTimeout(() => {
                            setCurrentTabIndex(currentTabIndex - 1);
                            setIsFading(false);
                        }, 200);
                    }}
                >
                    {Lang(lang, 'previous')}
                </button>
                <button
                    type="submit"
                    className={
                        "rounded-full px-4 py-1 text-sm " +
                        (isEdit
                            ? "text-white bg-red-500 hover:bg-red-600"
                            : "border border-red-500 text-red-500 hover:bg-gray-50")
                    }
                    onClick={() => {

                        setIsFading(true);
                        setTimeout(() => {
                            if ((currentTabIndex + 1) > profileCompletion) {
                                updatePercentage(currentTabIndex + 1)
                            }
                            setCurrentTabIndex(currentTabIndex + 1);
                            setIsFading(false);
                        }, 200);
                    }}
                >
                    {Lang(lang, 'next')} {currentTabIndex + 1}/10
                </button>
            </div>}

        </div>
    );
};

export default SocialMediaForm;
